//Scrolling Menu Componenent
export default class ScrollingMenu extends React.Component {
    constructor(props) {
        super(props);
        this.sendUrlCategoryData = this.sendUrlCategoryData.bind(this);
        this.makeActive = this.makeActive.bind(this);
        this.highlightAndUpadateUrl = this.highlightAndUpadateUrl.bind(this);
        this.automateLinkHighlight = this.automateLinkHighlight.bind(this);
        this.scrollMenuLinksToView = this.scrollMenuLinksToView.bind(this);
        this.jumpToSection = this.jumpToSection.bind(this);
    }

    componentDidMount() {
        console.log(this.props.autoLinkData);
        let currentPath = location.pathname;
        if (currentPath) { this.automateLinkHighlight(currentPath); }
        window.addEventListener('scroll', this.handleScroll);
    }
    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }
    automateLinkHighlight(currentURL) {
        if (currentURL) {
            let selectedLink = document.querySelector(".sub-navigation-primary-container a[href='" + currentURL + "']");
            if (selectedLink) {
                selectedLink.classList.add("_activeLink");
                //Bring hidden links to view
                this.scrollMenuLinksToView(selectedLink);
            }
        }
    }
    scrollMenuLinksToView(element) {
        setTimeout(() => {
            if (element) { element.scrollIntoView({ behavior: "instant", block: "nearest" }); }
        }, 1300);
    }
    highlightAndUpadateUrl(element) {
        element.preventDefault();
        $(".sub-navigation-primary-container a").removeClass('_activeLink');
        $(element.target).addClass('_activeLink');

        $(element.target).focus();
        $(element.target).attr("role", "status");
        $(element.target).attr("aria-selected", "true");
        $(element.target).attr("aria-live", "polite");

        //update url
        history.pushState({}, "Menu", element.target.pathname);
    }
    makeActive(e) {
        this.highlightAndUpadateUrl(e)
        this.props.resetMenuCatPage(e);
        this.handleDisclaimer(e);
        $('.mdl-layout__content .brandSection.aboutBrand').css('display', 'block');
        $('.disclaimerList.mc-disclaimer').css('display', 'block');
        $('.disclaimerList.sc-disclaimer').css('display', 'none');
        $(".main-menus-topsection.container").show();
    }
    scrollToTheLeft(e) {
        e.preventDefault();
        document.getElementById('menu-nav').scrollLeft -= 300
    }
    scrollToTheRight(e) {
        e.preventDefault();
        document.getElementById('menu-nav').scrollLeft += 300
    }
    sendUrlCategoryData(e) {
        this.highlightAndUpadateUrl(e)
        this.props.sendUrlCategoryData(e.target.pathname);
        this.handleDisclaimer(e);
        $(document).ready(function () {
            //$('.ihop2-subnav-primary-container .secondary-navigation-container #menu-nav .scrolltab a._activeLink').focus();
            //$('.ihop2-subnav-primary-container .secondary-navigation-container #menu-nav .scrolltab a._activeLink').attr("role", "alert");
            DE.OrderBag.bindEventsToDOM();
            $('.mdl-layout__content .brandSection.aboutBrand').css('display', 'none');
            $('.disclaimerList.mc-disclaimer').css('display', 'none');
            $('.disclaimerList.sc-disclaimer').css('display', 'block');
        });
    }
    handleDisclaimer(e) {
        $(document).ready(function () {
            DE.MenuDetails.handleSodiumDisclaimer();
        });
    }
    menuModalShow(e) {
        e.preventDefault();
        //$('body.ihop-wrapper').addClass('modal-open');
        $('#menulist-modal-container').modal("show");
        $('#menulist-modal-container .close-btn .close').focus();
    }
    menuModalHide(e) {
        e.preventDefault();
        //$('body.ihop-wrapper').removeClass('modal-open');
        $('#menulist-modal-container').modal("hide");
        $('.menu-app-component .combo-container-fluid .left-arrow').focus();
    }
    jumpToSection(element) {
        element.preventDefault();
        if ($('#menulist-modal-container').css('display') === 'block') {
            $('.modal.docked-right-modal#menulist-modal-container .modal-dialog .menulist-menuname .menulist-menuname-item').css({ 'font-weight': '300', 'text-decoration': 'none' });
            $('#menulist-modal-container').modal("hide");
        }
        var categoryTarget = $(element.target).data("category"),
            targetDevice;
        if ($('.menu-app-component .menu-main-layout .main-menus-topsection .topmenurow .menucarouselstyle .menu-owl-carousel').children().length < 1) {
            // Desktop Target
            if ($(window).width() > 960) {
                targetDevice = 50;
            }
            // Mobile Target
            if ($(window).width() < 960) {
                if ($('.ihop-listing-menucards.menu-cards-section').hasClass('menutexthidden')) {
                    $('.ihop-listing-menucards.menu-cards-section').removeClass('menutexthidden');
                }
                targetDevice = 80;
            }
        }
        else {
            var eleHeight = $('.menu-app-component .menu-main-layout .main-menus-topsection .topmenurow .menucarouselstyle').height();
            // Desktop Target
            if ($(window).width() > 960) {
                targetDevice = eleHeight + 40;
            }
            // Mobile Target
            if ($(window).width() < 960) {
                targetDevice = eleHeight - 10;
            }
        }
        if ($('.categories-menu-page .menu-text').hasClass('d-none')) {
            // Desktop Target
            if ($(window).width() > 960) {
                targetDevice = -20;
            }
            // Mobile Target
            if ($(window).width() < 960) {
                $('.ihop-listing-menucards.menu-cards-section').addClass('menutexthidden');
                targetDevice = -5;
            }
        }
        setTimeout(() => {
            $('html,body').animate({
                scrollTop: $("#" + categoryTarget).position().top += targetDevice
            });
        }, 800);
    }
    handleScroll(event) {
        if (document.body.classList.contains('modal-open')) {
            return;
        }
        const categorySections = document.querySelectorAll('.ihop-listing-menucards-subcategory');
        let currentSectionId = '';
        var targetDevice;
        if (categorySections) {
            categorySections.forEach(section => {
                const rect = section.getBoundingClientRect();
                // Desktop Target
                if ($(window).width() > 960) {
                    targetDevice = $('#' + section.id).height();
                }
                // Mobile Target
                if ($(window).width() < 960) {
                    targetDevice = $('#' + section.id).height();
                }
                if ($('.ihop-listing-menucards-subcategory-link.menuhighlight').length > 1) {
                    $('.scrolling-menu-item-list.activeparent').eq(0).children('.menuhighlight').removeAttr('style');
                    $('.scrolling-menu-item-list.activeparent').eq(0).children('.menuhighlight').removeClass('menuhighlight');
                }
                if ($('#menulist-modal-container').css('display') === 'none') {

                    if (rect.top + targetDevice >= 40 && rect.top <= window.innerHeight / 1.9) {
                        currentSectionId = section.id;
                        $('.ihop-listing-menucards-subcategory-link[data-category=' + section.id + ']').addClass('menuhighlight');
                        $('.ihop-listing-menucards-subcategory-link[data-category=' + section.id + ']').parent().addClass('activeparent');
                        $('.ihop-listing-menucards-subcategory-link[data-category=' + section.id + ']').focus();
                        $('.ihop-listing-menucards-subcategory-link[data-category=' + section.id + ']').css({ 'font-weight': '900', 'text-decoration': 'underline' });
                        $('.categories-menu-page .sub-navigation-primary-container .scrolltab .scrolling-menu-item-list').eq(0).removeClass('active-first');
                        $('.categories-menu-page .sub-navigation-primary-container .scrolltab .scrolling-menu-item-list').eq(0).css({ 'font-weight': '300', 'text-decoration': 'none' });
                        var menuActiveItem = $('.ihop-listing-menucards-subcategory-link.menuhighlight');
                        // Desktop Target
                        if ($(window).width() >= 2001) {
                            var menuActiveItemPosition = menuActiveItem.offset().left - 190;
                        }
                        else if ($(window).width() <= 2000 && $(window).width() >= 1901) {
                            var menuActiveItemPosition = menuActiveItem.offset().left - 185;
                        }
                        else if ($(window).width() <= 1900 && $(window).width() >= 1801) {
                            var menuActiveItemPosition = menuActiveItem.offset().left - 175;
                        }
                        else if ($(window).width() <= 1800 && $(window).width() >= 1601) {
                            var menuActiveItemPosition = menuActiveItem.offset().left - 160;
                        }
                        else if ($(window).width() <= 1600 && $(window).width() >= 1481) {
                            var menuActiveItemPosition = menuActiveItem.offset().left - 150;
                        }
                        else if ($(window).width() <= 1480 && $(window).width() >= 1371) {
                            var menuActiveItemPosition = menuActiveItem.offset().left - 140;
                        }
                        else if ($(window).width() <= 1370 && $(window).width() >= 1281) {
                            var menuActiveItemPosition = menuActiveItem.offset().left - 130;
                        }
                        else if ($(window).width() <= 1280 && $(window).width() > 660) {
                            var menuActiveItemPosition = menuActiveItem.offset().left - 120;
                        }
                        // Mobile Target
                        else if ($(window).width() <= 659 && $(window).width() >= 500) {
                            var menuActiveItemPosition = menuActiveItem.offset().left - 100;
                        }
                        else if ($(window).width() <= 499 && $(window).width() >= 420) {
                            var menuActiveItemPosition = menuActiveItem.offset().left - 81;
                        }
                        else {
                            var menuActiveItemPosition = menuActiveItem.offset().left - 85;
                        }
                        document.getElementById('menu-nav').scrollLeft += menuActiveItemPosition
                        $('.ihop-listing-menucards-subcategory-link[data-category=' + section.id + ']').css({ 'font-weight': '900', 'text-decoration': 'underline' });
                    }
                    else {
                        $('.ihop-listing-menucards-subcategory-link[data-category=' + section.id + ']').removeClass('menuhighlight');
                        $('.ihop-listing-menucards-subcategory-link[data-category=' + section.id + ']').parent().removeClass('activeparent');
                        $('.ihop-listing-menucards-subcategory-link[data-category=' + section.id + ']').blur();
                        $('.ihop-listing-menucards-subcategory-link[data-category=' + section.id + ']').css({ 'font-weight': '300', 'text-decoration': 'none' });
                    }
                }
            });
        }
    }
    render() {
        return (
            <div>
                <div className="combo-container-fluid">
                    <div className="row sub-navigation-primary-container sticky-menu">
                        <div className="col-1 no-padding static-menu-item" id="menulistmodal" onClick={this.menuModalShow} data-toggle="modal" role="link" tabIndex="0">
                            <a href="#" title="Menu Category List">
                                <img src="/-/media/ihop/images/menu/menu-list-svg.svg" className="menulistmodal-container" alt="Menu List Icon" />
                            </a>
                        </div>
                        <div onClick={this.scrollToTheLeft} className="col-1 no-padding static-menu-item directional-scrolling-menu-arrows left-arrow"></div>
                        <div className="col-8 adjustment px-0">
                            <header className="secondary-navigation-container">
                                <nav id="menu-nav" className="center scrolltab">
                                    {this.props.categories.map(category => {
                                        return (
                                            <span role="link" className="scrolling-menu-item-list regular-scrolling-menu-item-list"><a onClick={this.jumpToSection} href={'#' + category.PageUrl.split('/')[3]} className="ihop-listing-menucards-subcategory-link" data-category={category.PageUrl.split('/')[3]} aria-describedby={category.Name}>{category.Name}</a></span>
                                        );
                                    })}
                                </nav>
                            </header>
                        </div>
                        <div onClick={this.scrollToTheRight} className="d-sm-block col-1 static-menu-item directional-scrolling-menu-arrows right-arrow"></div>
                    </div>
                    {/*<p className="menu-text"><strong>{this.props.deliveryFeeStandard} </strong></p>*/}
                </div>
                <div className="modal modal_outer docked-right-modal fade" id="menulist-modal-container" aria-labelledby="menuList" aria-modal="true" role="dialog" tabIndex="0">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content ">
                            <div className="modal-body">
                                <div className="header-btns">
                                    <div className="position-relative close-btn clearfix">
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.menuModalHide} role="link" tabIndex="0">
                                            <i className="bi bi-x-circle text-blue" aria-hidden="false"></i>
                                        </button>
                                    </div>
                                </div>
                                <div className="col-12 menulist-menuname">
                                    {this.props.categories.map(categorys => {
                                        return (
                                            <div role="link" className="scrolling-menu-item-list regular-scrolling-menu-item-list menulist-menuname-item"><a onClick={this.jumpToSection} href={'#' + categorys.PageUrl.split('/')[3]} className="ihop-listing-menucards-subcategory-link" data-category={categorys.PageUrl.split('/')[3]} aria-describedby={categorys.Name}>{categorys.Name}</a></div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>

        );
    }
}

// Exd of Scrolling Menu Componenent